import React, { useContext, useRef } from 'react';

import {
  Bot,
  ChevronUpSquare,
  GanttChartSquare,
  Lightbulb,
  Menu,
  ScrollText,
  User,
} from 'lucide-react';

import { CompanyContext } from 'common/containers/CompanyContainer';
import { LocationContext, RouterContext } from 'common/containers/RouterContainer';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import OnboardingProgressIndicator from 'common/subdomain/admin/AdminOnboarding/InAppOnboarding/OnboardingProgressIndicator';
import DropdownMenu from 'common/ui/DropdownMenu';
import styles from 'css-module/components/subdomain/admin/v2/_AdminV2Nav.module.scss';

import CannyIcon from 'img/canny-icon.svg';

const AdminV2NavMobileMenu = () => {
  const company = useContext(CompanyContext);
  const location = useContext(LocationContext);
  const router = useContext(RouterContext);

  const buttonRef = useRef<HTMLButtonElement>(null);

  const isIDBEnabled = company?.featureAllowlist?.includes('idea-database');

  const Options = [
    {
      prefixIcon: Lightbulb,
      label: 'Ideas',
      value: '/admin/ideas',
      hidden: !isIDBEnabled,
    },
    {
      prefixIcon: ChevronUpSquare,
      label: 'Feedback',
      value: '/admin/feedback',
    },
    {
      prefixIcon: GanttChartSquare,
      label: 'Roadmap',
      value: '/admin/roadmap',
    },
    {
      prefixIcon: User,
      label: 'Users',
      value: '/admin/users',
    },
    {
      prefixIcon: ScrollText,
      label: 'Changelog',
      value: '/admin/changelog',
      hidden: !company.showChangelog,
    },
    {
      prefixIcon: Bot,
      label: 'Autopilot',
      value: '/admin/autopilot',
    },
  ].filter((option) => !option.hidden);

  return (
    <ul className={styles.navSection} data-screen-size="mobile">
      <li className="relative">
        <OnboardingProgressIndicator />
        <Link className={styles.cannyLogoLink} to="/admin/getting-started">
          <LazyLoadedImage className={styles.cannyLogoImage} alt="Canny Home" src={CannyIcon} />
        </Link>
      </li>
      <li>
        <DropdownMenu>
          <DropdownMenu.Trigger>
            <button aria-label="Menu" className={styles.iconLink} ref={buttonRef}>
              <Menu className={styles.icon} />
            </button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content align="start" side="bottom" sideOffset={8}>
            {Options.filter((option) => !option.hidden).map((option) => {
              const isSelected = location.pathname.startsWith(option.value);
              return (
                <DropdownMenu.Item
                  key={option.value}
                  icon={option.prefixIcon}
                  iconSize={16}
                  iconStrokeWidth={2}
                  label={option.label}
                  onSelect={() => {
                    router.push(option.value);
                  }}
                  selected={isSelected}
                />
              );
            })}
          </DropdownMenu.Content>
        </DropdownMenu>
      </li>
    </ul>
  );
};

export default AdminV2NavMobileMenu;
